import { render, staticRenderFns } from "./CreatorDirectMessage.vue?vue&type=template&id=d08014ea&scoped=true"
import script from "./CreatorDirectMessage.vue?vue&type=script&lang=js"
export * from "./CreatorDirectMessage.vue?vue&type=script&lang=js"
import style0 from "./CreatorDirectMessage.vue?vue&type=style&index=0&id=d08014ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08014ea",
  null
  
)

export default component.exports